import {crmEn} from "../opportunities";
import {commercialPricingEn} from '../commercialPricing';
import { productionMaterialsEn } from '../productionMaterials';
import { executionEn } from '../productionExecution';
import { qualitySpecsEn } from '../qualitySpecs';
import { productionEn } from '../production';
import { dataExportEn } from '../dataExport';
import { docExportEn } from '../documentExport';
import { sourcingEn } from '../sourcing';
import { mrpEn } from '../mrp';
import { unitPricingEn } from '../unitPricing';
import { soEn } from '../salesOrders';
import { previewEn } from '../featurePreview';
import { binsEn } from '../warehouseBins';
import { requisitionsEn } from '../requisitions';
import { routingsEn } from '../routings';
import { bomsEn } from '../boms';
import { transfersEn } from '../transfers';
import { reservationsEn } from '../reservations';
import { stockCountsEn } from '../stockCounts';
import { subcontractEn } from '../subcontract';
import { ncrEn } from '../ncr';
import { salesIssuesEn } from '../salesIssues';
import { ticketsEn } from '../tickets';
import { claimsEn } from '../claims';
import { supplierClaimsEn } from '../supplierClaims';
import { glEn } from '../gl';
import { kpisEn } from '../kpis';
import { userAccessEn } from '../userAccess';
import { pProcessEn } from '../pProcess';
import { redPiEn } from '../redPi';
import { orderProcessEn } from '../orderProcess';
import { portalEn } from '../portal';
import { devicesEn } from '../devices';
import { iqcEn } from "../iqc";
import { warehouseEn } from "../warehouse";
import { releasesEn } from "../releases";
import { settingsWorkspaceEn } from "../settingsWorkspace";
import { userWorkspaceEn } from "../userWorkspace";
import { profitWorkspaceEn } from "../profitWorkspace";
import { statementWorkspaceEn } from "../statementWorkspace";
import { quotationWorkspaceEn } from "../quotationWorkspace";
import { deliveryWorkspaceEn } from "../deliveryWorkspace";
import { packingWorkspaceEn } from "../packingWorkspace";
import { invoiceWorkspaceEn } from "../invoiceWorkspace";
import { piWorkspaceEn } from "../piWorkspace";
import { piPickerEn } from "../piPicker";
import { fxSettingsEn } from "../fxSettings";
import { fxConvertEn } from "../fxConvert";
import { packingBatchEn } from "../packingBatch";
import { evidenceEn } from "../evidence";
import { cardWorkspaceEn } from "../cardWorkspace";
import { sampleWorkspaceEn } from "../sampleWorkspace";
import { poWorkspaceEn } from "../poWorkspace";
import { productListEn } from "../productList";
import { productEditorEn } from "../productEditor";
import { productStockEn } from "../productStock";
import { openingImportEn } from "../openingImport";
import { lotLabelsEn } from "../lotLabels";
import { scanTasksEn } from "../scanTasks";
import { productWorkspaceEn } from "../productWorkspace";
export const en = {
  crm: crmEn,
 commercialPricing: commercialPricingEn,
  unitPricing: unitPricingEn,
  mrp: mrpEn,
  productionMaterials: productionMaterialsEn,
  execution: executionEn,
  qualitySpecs: qualitySpecsEn,
  production: productionEn,
  dataExport: dataExportEn,
  docExport: docExportEn,
  sourcing: sourcingEn,
  transfers: transfersEn,
  reservations: reservationsEn,
  stockCounts: stockCountsEn,
  subcontract: subcontractEn,
  ncr: ncrEn,
  salesIssues: salesIssuesEn,
  tickets: ticketsEn,
  claims: claimsEn,
  supplierClaims: supplierClaimsEn,
  gl: glEn,
  kpis: kpisEn,
  userAccess: userAccessEn,
  pProcess: pProcessEn,
  redPi: redPiEn,
  orderProcess: orderProcessEn,
  portal: portalEn,
  devices: devicesEn,
  boms: bomsEn,
  routings: routingsEn,
  requisitions: requisitionsEn,
  so: soEn,
  preview: previewEn,
  bins: binsEn,
  iqc: iqcEn,
  warehouse: warehouseEn,
  releases: releasesEn,
  settingsWorkspace: settingsWorkspaceEn,
  userWorkspace: userWorkspaceEn,
  profitWorkspace: profitWorkspaceEn,
  statementWorkspace: statementWorkspaceEn,
  quotationWorkspace: quotationWorkspaceEn,
  deliveryWorkspace: deliveryWorkspaceEn,
  packingWorkspace: packingWorkspaceEn,
  invoiceWorkspace: invoiceWorkspaceEn,
  piWorkspace: piWorkspaceEn,
  piPicker: piPickerEn,
  fxSettings: fxSettingsEn,
  fxConvert: fxConvertEn,
  packingBatch: packingBatchEn,
  evidence: evidenceEn,
  companySwitch: {
    vn: "VN",
    cn: "CN",
    label: "Company",
    all: "All companies",
    hint: "View one company only — every screen, list, report and statement follows. All shows both and labels each record with its company.",
    lockedEditing: "Save or cancel the record you are editing before switching company.",
  },
  cardWorkspace: cardWorkspaceEn,
  sampleWorkspace: sampleWorkspaceEn,
  poWorkspace: poWorkspaceEn,
  productList: productListEn,
  productEditor: productEditorEn,
  productWorkspace: productWorkspaceEn,
  ...productStockEn,
  ...openingImportEn,
  ...lotLabelsEn,
  ...scanTasksEn,
  brand: { tagline: "Trading · ERP" },
  trainingEnv: {
    label: "Training environment",
    detail: "Sample data — try every feature freely; nothing here affects the live system.",
  },
  piStatus: {
    title: "PI status",
    intro: "Which proforma invoices need attention: missing cost, mixed units, draft or mismatched purchase orders. This page carries no money at all — no revenue, cost, margin or unit price, not even in the data behind it.",
    piNo: "Proforma invoice", customer: "Customer", date: "Date", quantity: "Quantity",
    invoice: "Invoice", invoiced: "Invoiced", notInvoiced: "Not invoiced",
    costCoverage: "Cost coverage", needsAttention: "Needs attention", noIssue: "Nothing outstanding",
    empty: "No proforma invoice in this period.", error: "Could not load PI status.",
    coverage: { po: "From purchase orders", mixed: "Mixed sources", catalog: "From catalog", missing: "Incomplete" },
    issues: {
      missing_catalog_cost: "No cost on file", invalid_cost: "Invalid cost", currency_mismatch: "Currency mismatch",
      unit_mismatch: "Unit mismatch", draft_po: "Draft purchase order", po_charges_excluded: "PO freight/tax excluded",
      legacy_cost_baseline: "Legacy cost baseline",
    },
  },
  priceTiers: {
    title: "Quantity price tiers",
    intro: "Selling price by order quantity, the same for every customer. Enter only the quantity each tier starts at — the next tier closes the one before it. A customer's own agreed price still wins over these tiers, and the under-MOQ price is separate.",
    fromQuantity: "From quantity", price: "Price ({{currency}})", range: "{{from}} – {{to}}", andUp: "and up",
    add: "Add tier", hintTier: "tier from {{from}}", hintUnderMoq: "under-MOQ price", hintCustomer: "this customer\u2019s price", hintApply: "Click to use this price", empty: "No tier yet — the product selling price is used.",
    invalid: "Enter a whole starting quantity of 1 or more and a valid price.",
    duplicate: "Two tiers cannot start at the same quantity.",
    error: "Could not load or save the price tiers.",
  },
  mail: {
    title: "Send by email", from: "From", to: "To", toPlaceholder: "customer@example.com",
    subjectLabel: "Subject", body: "Message", send: "Send", noMailbox: "No mailbox configured",
    notConfigured: "No sending mailbox is configured yet, so the message cannot be sent. The draft below is ready — add the mailbox details and it will send from here.",
    error: "Could not send the message.",
    greeting: "Dear {{customer}},", closing: "Best regards,",
    subject: { pi: "Proforma invoice {{documentNo}}", sampleOrder: "Sample order {{documentNo}}" },
    intro: { pi: "Please find the details of proforma invoice {{documentNo}} below.", sampleOrder: "Please find the details of sample order {{documentNo}} below." },
    line: { date: "Date: {{date}}", customerPo: "Your PO: {{po}}", products: "Items: {{codes}}" },
  },
  productFiles: {
    title: "Product files (administrators only)",
    intro: "Drawings, technical PDFs, Office documents and archives, up to {{max}} each. Large files are split in the browser and sent in parts through this site, so a CAD file still uploads from a normal connection. Only administrators can upload or download — the catalog and approval images are unaffected.",
    choose: "Choose a file", uploading: "Uploading…", empty: "No file yet.",
    progress: "{{name}} · part {{done}} of {{total}}",
    error: "Could not load, upload or delete the file.",
    reject: { empty_name: "The file has no name.", too_large: "The file must be {{max}} or smaller.", blocked_type: "Files that can run when opened are not allowed (exe, js, html, svg…)." },
  },
  nav: {
    opportunities: "Sales opportunities",
    sourcing: "RFQ & supplier quotes",
    mrp: "Material planning (MRP)",
    unitPricing: "Units & price profiles",
    pendingReview: "Awaiting customer confirmation",
    walkthroughDone: "Reviewed with the owner {{date}}",
    overview: "Overview & Reports",
    dashboard: "Dashboard",
    analytics: "Sales Analytics",
    profit: "Profit Summary",
    piStatus: "PI status",
    kpis: "Operations KPIs",
    orderProcess: "Order process",
    pProcess: "P-Process",
    portal: "Supplier portal",
    devices: "Scan & labels",
    masterData: "Master Data",
    products: "Products",
    customers: "Customers",
    customerTerms: "Payment terms & order requirements",
    suppliers: "Suppliers",
    sales: "Sales",
    proformaInvoices: "Proforma Invoices",
    redPi: "Red PI",
    invoices: "Invoices",
    quotations: "Quotations",
    packingLists: "Packing Lists",
    deliveryNotes: "Delivery Notes",
    statement: "Statement (A/R)",
    procurement: "Purchasing",
    purchaseOrders: "Purchase Orders",
    supplierClaims: "Supplier claims",
    samples: "Samples",
    sampleOrders: "Sample Orders",
    sampleCards: "Sample Cards",
    erp: "ERP Modules",
    warehouse: "Warehouse & LOT",
    warehouseLocations: "Warehouse locations",
    production: "Production",
    quality: "Quality",
    finance: "Journal Entries",
    admin: "Administration",
    settings: "Settings",
    users: "User Management",
    deletedRecords: "Deleted Records",
    routings: "Routings",
    boms: "Bills of Materials",
    salesOrders: "Sales Orders",
    requisitions: "Purchase Requisitions",
    stockMoves: "Stock Movements",
    glAccounts: "Chart of Accounts",
    serviceTickets: "After-sales",
    inventoryDelivery: "Inventory & Delivery",
    manufacturingQuality: "Manufacturing & Quality",
    financeReceivables: "Finance & Receivables",
    inDevelopment: "In development",
    inProgress: "In progress",
  },
  common: {
    internalReference: "Internal order",
    internalReferenceHint: "A document of a customer you are not permitted to see — stock and production still work with this order; only its number and customer are hidden.",
    internalSupplier: "Internal supplier",
    internalSupplierHint: "A private supplier you are not permitted to see — the document still shows so the warehouse can work, but only administrators and that supplier's followers see the name and can change it.",
    printLanguage: "Print using",
    printLanguage_en: "English",
    printLanguage_zh: "Chinese",
    labelLanguage: "Label language",
    labelLanguage_en: "English",
    labelLanguage_zh: "Chinese",
    labelLanguage_both: "English + Chinese",
    labelLanguageHint: "Chosen when printing and applied to every label in this print. Your choice is remembered on this device.",
    descriptionLangHint: "The description column below is editing the {{lang}} text. Switch above to edit and print the other one.",
    rowNumber: "No.",
    search: "Search",
    typeToSearch: "Type a few letters to search…",
    searchPlaceholder: "Search documents, customers, products…",
    new: "New",
    create: "Create",
    export: "Export",
    print: "Print",
    filter: "Filter",
    all: "All",
    cancel: "Cancel",
    continue: "Continue",
    close: "Close",
    save: "Save",
    edit: "Edit",
    actions: "Actions",
    language: "Language",
    webVersion: "v{{version}}",
    signOut: "Sign out",
    viewAll: "View all",
    noDocuments: "No documents yet.",
    documentsError: "Could not load documents.",
    removeFilter: "Remove filter",
    soon: "Coming soon",
    loading: "Loading…",
    /** Mảnh cuối của thanh đường dẫn khi chứng từ không mở được (ngoài phạm vi, đã xoá, lỗi mạng) — thay "Đang tải…". */
    unavailable: "Unavailable",
    savedShort: "Saved",
    saving: "Saving…",
    creating: "Creating…",
    uploading: "Uploading…",
    retry: "Retry",
    delete: "Delete",
    confirmArchive: "This record will be archived and can be restored later.",
    refresh: "Refresh",
    remove: "Remove",
    restore: "Restore",
    add: "Add",
    addLine: "Add line",
    removeLine: "Remove line",
    removeContact: "Remove contact",
    deletePayment: "Delete payment",
    noMatches: "No matches",
    editMode: "Edit",
    createMode: "Create",
    saved: "Saved.",
    unsavedTitle: "Discard unsaved changes?",
    unsavedDescription: "Your changes haven't been saved. If you close now, they will be lost.",
    keepEditing: "Keep editing",
    discardChanges: "Discard changes",
    openNavigation: "Open navigation",
    closeNavigation: "Close navigation",
    toggleSidebar: "Toggle sidebar",
    primaryNavigation: "Primary navigation",
    breadcrumb: "Breadcrumb",
    name: "Name",
    email: "Email",
    password: "Password",
    role: "Role",
    status: "Status",
    date: "Date",
    type: "Type",
    total: "Total",
    product: "Product",
    customer: "Customer",
    supplier: "Supplier",
    items: "Items",
    remarks: "Remarks",
    code: "Code",
    description: "Description",
    color: "Color",
    size: "Size",
    colorSize: "Color / Size",
    quantity: "Quantity",
    qty: "Qty",
    unitPrice: "Unit price",
    amount: "Amount",
    subtotal: "Subtotal",
    delivery: "Delivery",
    shipping: "Shipping",
    method: "Method",
    address: "Address",
    phone: "Phone",
    taxId: "Tax ID",
    reference: "Reference",
    fromPi: "From PI",
    shipTo: "Ship to",
    cartons: "Cartons",
    when: "When",
    age: "Age",
    version: "Version",
    location: "Location",
    result: "Result",
    rejected: "Rejected",
    planned: "Planned",
    produced: "Produced",
    priority: "Priority",
    subject: "Subject",
    lastLogin: "Last login",
    originalId: "Original ID",
    deletedBy: "Deleted by",
    currency: "Cur.",
    created: "Created / By",
    createdOn: "Created",
    yes: "Yes",
    no: "No",
    createdBy: "Created by",
    createdDate: "Created",
    invalidField: "Invalid value: {{field}}",
    lineError: "Line {{line}}: invalid {{field}}",
    subRef: "Sub ref",
    customerStyleNo: "Cust. style no.",
    unit: "Unit",
    moq: "MOQ",
    mcq: "MCQ",
    msq: "MSQ",
    dtdPrice: "DTD price",
    exwPrice: "EXW price",
    underMoqPrice: "Under-MOQ price",
    sampleLeadTime: "Sample L/T",
    bulkLeadTime: "Bulk L/T",
    image: "Image",
    lineRemark: "Line remark",
    currencyLabel: "Currency",
  },
  pagination: {
    label: "Pagination",
    range: "{{from}}–{{to}} of {{total}}",
    rowsPerPage: "Rows per page",
    pageOf: "Page {{page}} of {{pages}}",
    first: "First page",
    previous: "Previous page",
    next: "Next page",
    last: "Last page",
    goToPage: "Go to page",
  },
  login: {
    title: "Sign in",
    brandLogoAlt: "Hisense Button logo",
    subtitle: "Hisense Button · Management System",
    heroEyebrow: "Trading & Manufacturing ERP",
    heroTitle: "One unified platform, from sales to production.",
    heroDescription:
      "Bring sales, documents, sample management, and factory operations together in one multilingual system built for collaboration between Vietnam and China.",
    heroModules: "8 ERP modules",
    heroLanguages: "VI · EN · 中文",
    heroCloud: "Vietnam–China connectivity",
    builtBy: "Solution developed by ToanKhonTech",
    email: "Email",
    emailPlaceholder: "you@hisensebutton.com",
    audienceLabel: "Choose your portal",
    audienceStaff: "Hisense staff",
    audienceSupplier: "Supplier",
    supplierId: "Supplier id",
    supplierIdPlaceholder: "NCC-XXXXXX",
    staffHint: "Use your Hisense staff email and password.",
    wrongTabStaff: "That looks like a supplier id. Try the “Supplier” tab above.",
    wrongTabSupplier: "That looks like an email address. Try the “Hisense staff” tab above.",
    password: "Password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    remember: "Keep me signed in",
    supplierHint: "Use the supplier ID and password from Hisense.",
    submit: "Sign in",
    submitting: "Signing in…",
    demoLabel: "Demo account",
    errorInvalidCredentials: "Email or password is incorrect.",
    errorAccountDisabled: "This account has been disabled. Contact an administrator.",
    errorGeneric: "Sign-in failed. Please try again.",
  },
  dashboard: {
    activity: {
      pi_created: "raised a proforma invoice · {{amount}}",
      invoice_created: "raised an invoice · {{amount}}",
      quotation_created: "raised a quotation",
      po_created: "raised a purchase order · {{amount}}",
    },
    title: "Dashboard",
    subtitle: "Operations at a glance",
    revenueMTD: "Revenue · MTD",
    openPis: "Open Proforma Invoices",
    arOutstanding: "A/R Outstanding",
    arOverdue: "overdue",
    samples: "Samples in progress",
    noReorderPoint: "No reorder point set on {{count}} products",
    inventory: {
      title: "Warehouse follow-up",
      since: "(since {{since}}, the first posted opening balance)",
      deliveredNotIssued: "notes that left the warehouse without a goods source, or received more than was issued",
      invoicesFromStock: "invoices selling a stocked item without a delivery note recording the source",
      receivedNotStocked: "purchase orders marked delivered but not fully received into stock",
      directWithStock: "direct deliveries while the item was in stock — awaiting approver review",
      clear: "Warehouse: nothing outstanding (since {{since}}).",
      notStarted: "Lot-based stock has not started: no opening balance has been posted yet.",
      openCounts: "Enter opening balance",
    },
    activity7d: "Documents created · last 7 days",
    work: {
      unpaidPis: "proforma invoices not fully paid",
      expiredPis: "past their validity date",
      openPos: "purchase orders not fully delivered",
      openQuotations: "quotations on file",
    },
    lowStock: "Low-stock products",
    recentActivity: "Recent Activity",
    arAging: "A/R Aging",
    topCustomers: "Top Customers · Open A/R",
    awaiting: "awaiting collection",
    changeVsLastMonth: "{{value}}% vs last month",
    noPrevMonth: "No revenue last month to compare",
    currencyExcluded: "Excludes {{count}} document(s) in {{currency}}",
    errorLoad: "Could not load the dashboard.",
    paymentActivity: "recorded a {{method}} payment of {{amount}}",
    paymentMethod: "payment",
  },
  customers: {
    /** Dấu nối tên người theo đơn — tiếng Hoa dùng "、". */
    followersSeparator: ", ",
    followersLine: "Order followers: {{names}}",
    /** Khách riêng tư / liên hệ riêng tư (Roary 30/09/2026) — chỉ quản trị viên thấy và đặt được. */
    private: "Private customer",
    privateHint: "Only administrators can see this customer and all of its documents (quotations, PIs, invoices, packing lists, delivery notes, sample orders, statements, reports). Order followers, accounting and warehouse staff cannot see it either.",
    followersPrivate: "Private customer: order followers who are not administrators will not see this customer.",
    privateBadge: "Private",
    contactPrivate: "Administrators only",
    contactPrivateToggle: "Administrators only · contact {{n}}",
    contactsPrivateHint: "Click the lock in the name column so that only administrators can see that contact (for example the customer's boss). Other users do not see the contact in the profile, in search or in recipient pickers, and saving the customer does not remove it.",
    privateContactSuffix: " (administrators only)",
    followerAdd: "Add an order follower…",
    followerRemove: "Remove {{name}}",
    followerOptionsError: "Could not load the staff list.",
    followerUnreachable: "{{names}}: cannot see this customer (other region or disabled account) — consider removing.",
    followerSelfLocked: "You only see the customers you follow, so your name always stays here.",
    followersHint: "Several people can follow one customer. Accounts limited to the customers they follow see this customer only if they are listed here.",
    followersNone: "No order follower yet — only administrators and accounts that see every customer can see this customer.",
    followerDisabled: "disabled",
    filterNoFollower: "No order follower",
    code: "Customer code / Short name",
    codeHint: "Internal reference, unique. Optional.",
    codeTaken: "This code is already used by another customer.",
    filterPrivate: "Private customers",
    filterPrivateHint: "Show only private customers (visible to administrators only). Combines with Vietnam / China — a private customer keeps its own company.",
    editCustomer: "Edit customer",
    editNamed: "Edit customer: {{name}}",
    backToList: "Back to customers",
    required: "Required",
    sectionSales: "Sales settings",
    moreContacts: "+{{count}} more contacts",
    errorDelete: "Could not delete customer.",
    notFound: "Customer not found.",
    title: "Customers",
    subtitle: "Master data · accounts & contacts",
    company: "Company",
    classification: "Class",
    vietnam: "Vietnam",
    china: "China",
    classificationLocked: "Fixed to your account's data region.",
    cs: "Order followers",
    terms: "Payment terms",
    contacts: "Contacts",
    contactCount: "Number of contacts",
    openAr: "Open A/R",
    newCustomer: "New customer",
    loading: "Loading customer…",
    errorLoad: "Could not load customers.",
    errorSave: "Could not save customer.",
    confirmDeleteNamed: "Delete {{name}}? It will be archived.",
    addContact: "Add contact",
    contactName: "Contact name",
    contactPersonN: "Contact {{n}}",
    phone1: "Phone 1",
    phone2: "Phone 2",
    wechat: "WeChat ID",
    section: "Section / Dept.",
    brandName: "Brand",
    team: "Team",
    contactsCountHint: "{{count}} of {{max}} contacts · a name is required on each",
    errorContactName: "Contact {{n}}: name is required.",
    selectTerm: "Select payment term",
    unassigned: "Unassigned",
    sectionCompany: "Company information",
    sectionContacts: "Contact persons",
    companyHint: "Name, address and phone printed on documents.",
    salesHint: "Payment terms, classification, order followers and the P-Process default for new PIs.",
    saveHint: "Contact rows left completely empty are dropped when you save.",
    sideShow: "Show extra columns",
    sideHide: "Hide extra columns",
    sideColumns: "Phone 2, brand, WeChat ID, team",
    sideLocked: "A contact uses the extra columns, so they stay visible.",
    piRef: "PI {{no}}",
    documents: "Recent documents",
    documentsHint: "The 5 latest of each kind. View all opens the list filtered to this customer.",
    itemCount: "{{count}} items",
    noContacts: "No contacts yet",
    openCustomer: "Open customer",
  },
  lot: {
    pProcessDefaultOff: "Off for new proforma invoices",
    pProcessDefaultOn: "On for new proforma invoices",
    number: "LOT No.",
    placeholder: "supplier batch",
    pProcess: "P-Process",
    pProcessHint: "Track lot numbers on every document for this order",
    pProcessDefault: "P-Process by default",
    pProcessDefaultHint: "Sets the default P-Process mode for new proforma invoices. Existing documents keep their own setting. LOT numbers are entered per line using the supplier’s batch number.",
  },
  products: {
    title: "Products",
    refs: "Sub / Customer ref",
    typeBrand: "Type / Brand",
    wireSize: "Wire size",
    weightPer100: "Weight/100",
    lowestPrice: "Lowest",
    upCharge: "Up charge",
    leadTime: "Lead time S/B",
    orderQty: "MOQ / MCQ·MSQ",
    storageLocation: "Storage / Location",
    currency: "Cur.",
    created: "Created / By",
    subtitle: "Master data · catalog & pricing",
    searchPlaceholder: "Search code, description, ref, brand, color…",
    allTypes: "All types",
    allBrands: "All brands",
    allApprovals: "All approvals",
    allSuppliers: "All suppliers",
    filterSearch: "Filter list…",
    code: "Code",
    description: "Description",
    descriptionEn: "Description in English",
    descriptionZh: "Description in Chinese",
    descriptionPrimary: "Use as the main one",
    descriptionHint: "The main one is copied into document lines and printed on labels. Which language a document prints is chosen on the document itself, because the same product can be sold to customers who read different languages. If one box is empty the other is used rather than printing nothing.",
    type: "Type",
    selectType: "Select a product type",
    legacyType: "current legacy value",
    brand: "Brand",
    color: "Color",
    size: "Size",
    colorZh: "Color (Chinese)",
    materialType: "Material type",
    materialTypeHint: "e.g. Brass, Stainless steel 304, Zinc alloy",
    materialWidth: "Material width",
    materialThickness: "Thickness",
    materialHardness: "Hardness / Temper",
    materialHardnessHint: "e.g. H14, 1/2H, HV 150",
    unit: "Unit",
    selectUnit: "Select a product unit",
    legacyUnit: "current legacy value",
    moq: "MOQ",
    stock: "Stock",
    approval: "Approval",
    sellingPrice: "Selling",
    sellingPriceHint: "Default list price · {{currency}}",
    costPrice: "Cost",
    supplier: "Supplier",
    supplierAndRef: "Supplier / Ref",
    newSampleOrderFrom: "New sample order from this product",
    newSampleCardFrom: "New sample card from this product",
    advancedFilters: "Advanced filters",
    clearFilters: "Clear filters",
    minPrice: "Selling price from",
    maxPrice: "Selling price to",
    minStock: "Stock from",
    maxStock: "Stock to",
    createdFrom: "Created from",
    createdTo: "Created to",
    rangeReversed: "The start value is greater than the end value — nothing can match.",
    newProduct: "New product",
    codeHint: "blank = auto-number",
    image: "Image",
    imagePreview: "Product image",
    viewImage: "View image",
    uploadImage: "Upload image",
    removeImage: "Remove",
    imageDropHint: "Drop or paste a photo",
    imageDropTitle: "Click to choose a photo, drag one here, or press {{shortcut}} to paste a copied photo (e.g. from WeChat).",
    imageDropNoFile: "No image file came through. Copy the photo (e.g. in WeChat) and press {{shortcut}} here, or save it and use Upload image.",
    invalidNumber: "Invalid number in",
    confirmDelete: "Delete this product? It will be archived and can be restored later.",
    loading: "Loading product…",
    errorLoad: "Could not load products.",
    errorSave: "Could not save product.",
    imageTooLarge: "Image must be 5MB or smaller (checked after compression).",
    imageBadType: "Only PNG, JPEG, WEBP or GIF images are accepted.",
    legacyNegative: "Legacy data: {{fields}} hold a negative value, which this form does not accept. Correct or clear those fields before saving.",
    errorUpload: "Image upload failed.",
    subRef: "Sub ref",
    subRefHint: "Optional variant code (color, size…)",
    customerRef: "Customer ref",
    supplierProductRef: "Supplier product ref",
    selectSupplier: "Select a supplier",
    currencyLabel: "Currency",
    lowestPriceHint: "Minimum acceptable selling price",
    sampleLeadTime: "Sample lead time (days)",
    bulkLeadTime: "Bulk lead time (days)",
    moqHint: "Total minimum order quantity",
    mcq: "MCQ",
    mcqHint: "Minimum quantity per color",
    msq: "MSQ",
    msqHint: "Minimum quantity per size",
    storage: "Storage",
    moldRef: "Mold ref",
    moldLocation: "Mold location",
    wire: {
      length: "Length",
      width: "Width",
      height: "Height",
      innerWidth: "Inner width",
      diameter: "Diameter",
      wireDiameter: "Wire diameter",
    },
    reorderPoint: "Reorder point",
    reorderPointHint: "Warn when stock falls below this. Leave blank for no warning — this is not MOQ.",
    storageHint: "Storage type or conditions",
    weightUnit: "Weight unit",
    wireLength: "Length",
    wireWidth: "Width",
    wireHeight: "Height",
    wireInnerWidth: "Inner width",
    wireDiameter: "Diameter",
    wireWireDiameter: "Wire diameter",
    approvalProof: "Approval proof",
    approvalProofHint: "Approval letter, email or certificate (optional)",
    uploadApprovalProof: "Upload proof",
    removeApprovalProof: "Remove proof",
    keepOpenNextCode: "Keep this form open with the next code after saving",
    sectionBasic: "Basic information",
    sectionSpecs: "Specifications",
    sectionSupplier: "Supplier",
    sectionPricing: "Pricing & lead times",
    sectionStatus: "Status & inventory",
    filterType: "All types",
    openProduct: "Open product details",
    notFound: "Product not found.",
    errorDelete: "Could not delete this product.",
  },
  pricing: {
    title: "Customer prices",
    hint: "These override the selling price for one customer. Everyone else uses the selling price above.",
    customer: "Customer",
    selectCustomer: "Select a customer",
    scope: "Applies to",
    listPrice: "List price",
    price: "Price",
    setPrice: "Set customer price",
    effective: "Effective",
    status: "Status",
    current: "Current",
    closed: "Closed",
    none: "No customer prices yet. Documents use the selling price above.",
    afterSave: "Save the product first, then open it to add customer prices.",
    invalidPrice: "Enter a valid price",
    errorSet: "Could not set price.",
    loading: "Loading prices…",
  },
  quotations: {
    no: "Quote No.",
    new: "New quotation",
    preparedBy: "Prepared by",
    lines: "Lines",
    subtitle: "Standalone price quotations",
    document: "Quotation",
    to: "To",
    attn: "Attn",
    errorLoad: "Could not load quotations.",
    errorSave: "Could not save quotation.",
    confirmDelete: "Delete quotation {{number}}?",
    printingDate: "Printing date",
    billToText: "Bill to (free text)",
    billToTextHint: "Carried over from the legacy system; set the customer above.",
    unknownCustomer: "Unknown customer (hidden when printed)",
    addProduct: "Add product",
    duplicateProduct: "That product is already on this quotation.",
  },
  samples: {
    courier: "Courier",
    trackingNo: "Tracking no.",
    shippedAt: "Ship date",
    newOrder: "New sample order",
    newCard: "New sample card",
    orderType: "Order type",
    team: "Team / dept.",
    labTest: "Lab test request",
    ordersSubtitle: "Development samples · lab tests",
    cardsSubtitle: "Reference sample cards",
    fromSupplier: "From supplier",
    toCustomer: "To customer",
    productNo: "Product No.",
    requestedShort: "Req",
    retainedShort: "Ret",
    orderNo: "SO No.",
    party: "Party",
    cardNo: "Card No.",
    errorOrders: "Could not load sample orders.",
    errorCards: "Could not load sample cards.",
    errorCreateOrder: "Could not create the sample order.",
    errorCreateCard: "Could not create the sample card.",
    errorUpload: "Image upload failed.",
    orderDelivery: "Order / Delivery",
    attachments: "Attachments",
    firstProduct: "Product",
    andMore: "+{{count}} more",
    contactEmail: "Contact email",
    contactHint: "Snapshotted when the order is created, so a reprint matches what was sent.",
    controlSample: "Control sample",
    productDesc: "Product / Description",
    orderDate: "Order date",
    deliveryDate: "Delivery date",
    editOrder: "Edit sample order",
    editCard: "Edit sample card",
    selectSupplier: "Search and select a supplier",
    selectCustomer: "Search and select a customer",
    contactPerson: "Contact person",
    selectContact: "Select a contact person",
    addProduct: "Add product",
    manualEntry: "Manual entry",
    manualBadge: "Manual",
    searchProducts: "Search by code, description, type or brand…",
    duplicateProduct: "This product is already on the order.",
    subRef: "Sub ref.",
    requestQuantity: "Request qty",
    retainedQuantity: "Retained qty",
    controlSampleNotes: "Control sample notes",
    useProductImage: "Use product image",
    noItems: "No products added yet",
    noItemsHint: "Use “Add product” to pick from the catalog, or “Manual entry” for an item that is not in it yet.",
    addFiles: "Add files",
    noAttachments: "No attachments yet",
    attachmentHint: "Images (JPG, PNG, WebP — max 5 MB) or documents (PDF, DOC, XLS, PPT — max 10 MB)",
    attachmentCount: "{{count}} / {{max}}",
    attachmentSizeKb: "{{size}} KB",
    deleteAttachment: "Delete attachment",
    selectLabTest: "Select a testing standard",
    labTestHint: "The testing standard required for this sample.",
    orderRemarks: "Order remarks",
    printDevSheet: "Print development sheet",
    devSheetTitle: "Development sheet",
    skippedExisting: "Skipped {{count}} already in the catalog: {{codes}}.",
    skippedIncomplete: "Skipped {{count}} missing a description or type: {{codes}}.",
    addToProductsFailed: "Could not add these lines to the catalog.",
    addToProducts: "Add to product data",
    addedToProducts: "Added {{count}} product(s) to the catalog.",
    alreadyInProducts: "This product code already exists in the catalog.",
    confirmDeleteOrder: "Delete this sample order? It will be archived and can be restored later.",
    confirmDeleteCard: "Delete this sample card? It will be archived and can be restored later.",
    errorSaveOrder: "Could not save the sample order.",
    errorSaveCard: "Could not save the sample card.",
    loadingOrder: "Loading sample order…",
    productNoRequired: "Product code is required.",
    typeRequired: "Type is required.",
    descriptionRequired: "Description is required.",
    document: "Sample Order",
    orderInfo: "Order information",
    supplierInfo: "Supplier information",
    orderDetails: "Order details",
    contactPhone: "Contact phone",
    autoNumberHint: "Number is assigned when you save",
    supplierRequired: "A supplier is required.",
    itemsRequired: "At least one product is required.",
    deliveryDateRequired: "Delivery date is required.",
    teamRequired: "Team / department is required.",
    duplicateProductNo: "This product code is already on the order.",
    changeStatus: "Change status",
    deleteOrder: "Delete sample order",
    deleteCard: "Delete sample card",
    openAttachment: "Open attachment",
    uploadInProgress: "Wait for the upload to finish before saving.",
    unsavedUploadsDescription: "This sample order has unsaved changes, including files you already uploaded. If you leave now, they will be lost.",
    loadingCard: "Loading sample card…",
  },
  suppliers: {
    classification: "Region",
    classificationHint: "The team that buys from this supplier. When both teams buy from the same factory, each team keeps its own record.",
    classificationChoose: "Choose a team",
    classificationLocked: "Your account works with one region only, so it cannot change a supplier's region.",
    unclassified: "Unclassified",
    unclassifiedHint: "Unclassified: both teams see this supplier until a team is chosen.",
    sectionAccess: "Access",
    accessHint: "Who looks after this supplier, and whether only some people may see it.",
    followers: "Followers",
    followerAdd: "Add a follower…",
    followersHint: "Staff who look after this supplier. A regular supplier is still visible to the whole team.",
    followersPrivateHint: "Private supplier: only administrators and these people see the record. Also chosen in Settings → Users → Permissions — it is the same list.",
    followersNone: "No follower yet.",
    adminOnly: "Only an administrator can change the followers or make a supplier private.",
    private: "Private supplier",
    privateHint: "Only administrators and followers see the record, the contacts and the cost on products. Others still see this supplier's purchase orders, receipts and payables, but the name shows as \"Internal supplier\" and they cannot change them.",
    privateBadge: "Private",
    contactPrivate: "Administrators only",
    contactPrivateToggle: "Administrators only · contact {{n}}",
    vietnam: "Vietnam",
    china: "China",
    portalLoginId: "Supplier portal login id",
    portalLoginHint: "Give this code to the supplier: it is the login name, not a secret; the password is what proves identity. Case does not matter.",
    portalLoginGenerate: "Generate",
    portalSection: "Supplier portal",
    portalIntro: "The supplier signs in with the code below and the password you set here. The account, its password and locking are all managed on this panel.",
    portalAfterSave: "Save the supplier first, then open the portal from the edit page.",
    portalNoAccount: "Portal not opened",
    portalStatusActive: "Open",
    portalStatusDisabled: "Locked",
    portalPassword: "Initial password",
    portalNewPassword: "New password",
    portalPasswordConfirm: "Repeat the password",
    portalPasswordHint: "At least 8 characters. Hand it to the supplier together with the code; they must change it on first sign-in. The system never shows it again.",
    portalOpen: "Open the portal",
    portalOpened: "Portal opened. Send the code and password to the supplier.",
    portalSaveLoginId: "Save code",
    portalLoginIdSaved: "Login code changed. The old code no longer works.",
    portalMustChange: "Still on the initial password: the supplier has not signed in and changed it yet.",
    portalPasswordChanged: "The supplier has changed their password.",
    portalLastLogin: "Last sign-in: {{when}}",
    portalNeverLoggedIn: "Never signed in.",
    portalResetPassword: "Reset password",
    portalResetDone: "Password reset. The supplier must change it again at next sign-in.",
    portalDisable: "Lock the portal",
    portalEnable: "Unlock the portal",
    portalDisabled: "Locked. The supplier cannot sign in until it is unlocked.",
    portalEnabled: "Portal unlocked.",
    portalError: "The portal account could not be updated.",
    companyContact: "Company contact",
    editSupplier: "Edit supplier",
    editNamed: "Edit supplier: {{name}}",
    backToList: "Back to suppliers",
    required: "Required",
    title: "Suppliers",
    subtitle: "Master data · vendors & contacts",
    company: "Company",
    address: "Address",
    phone: "Phone",
    email: "Email",
    contacts: "Contacts",
    contactCount: "Number of contacts",
    moreContacts: "+{{count}} more",
    newSupplier: "New supplier",
    addContact: "Add contact",
    contactName: "Contact name",
    contactCard: "Contact {{n}}",
    specialization: "Specialization",
    confirmDelete: "Delete this supplier? It will be archived and can be restored later.",
    loading: "Loading supplier…",
    errorLoad: "Could not load suppliers.",
    errorSave: "Could not save supplier.",
    phone1: "Phone 1",
    phone2: "Phone 2",
    wechat: "WeChat ID",
    selectSpecialization: "Select specialization",
    openSupplier: "Open supplier details",
    notFound: "Supplier not found.",
    errorDelete: "Could not delete this supplier.",
    sectionCompany: "Company",
    companyHint: "Name, address, phone and email printed on purchase documents.",
    contactsCountHint: "{{count}}/{{max}} contacts · every contact needs a name",
    saveHint: "Contact rows left completely empty are dropped when you save.",
    sideShow: "Show extra columns",
    sideHide: "Hide extra columns",
    sideColumns: "Phone 2, WeChat ID",
    sideLocked: "A contact uses the extra columns, so they stay visible.",
    noContacts: "No contacts on this supplier.",
    viewProducts: "View products",
    documents: "Recent documents",
    documentsHint: "The 5 latest of each kind. View all opens the list filtered to this supplier.",
    contactsCount: "Contacts · {{count}}",
  },
  pi: {
    title: "Proforma Invoices",
    subtitle: "Root sales document · payments sub-ledger",
    piNo: "PI No.",
    date: "Date",
    billTo: "Bill to",
    poNo: "Customer PO",
    total: "Total",
    paid: "Paid",
    balance: "Balance",
    status: "Status",
    respBy: "Resp. by",
    billToContact: "Bill to / Contact",
    notifyParty: "Notify party / Contact",
    consignee: "Consignee / Contact",
    paymentCompany: "Payment company",
    invoiceStatus: "Invoice",
    notInvoiced: "Not invoiced",
    newPi: "New PI",
    lineItems: "Line items",
    receivableTitle: "Paid against each invoice",
    stillOwed: "Still owed",
    unapplied: "Received but not yet applied to any invoice",
    payments: "Payments",
    item: "Item",
    description: "Description",
    qty: "Qty",
    exwTag: "EXW",
    exwUsedOnPrint: "This line prints at its EXW price.",
    unitPrice: "Unit price",
    amount: "Amount",
    noPayments: "No payments recorded yet.",
    recordPayment: "Record payment",
    convertInvoice: "Create invoice",
    createPacking: "Create packing list",
    createPo: "Create PO",
    document: "Proforma Invoice",
    invoiced: "Invoiced",
    delivery: "Delivery",
    shipping: "Shipping",
    method: "Method",
    subtotal: "Subtotal",
    linesCount: "{{count}} lines",
    errorLoad: "This proforma invoice could not be loaded.",
    errorList: "Could not load proforma invoices.",
    errorCreateInvoice: "Could not create invoice.",
    errorRecordPayment: "Could not record payment.",
    validAmount: "Enter a valid amount.",
    adminOnly: "Administrators only",
    adminOnlyHint: "Only administrator accounts see this proforma invoice and every document that comes from it. This cannot be undone later.",
    adminOnlyAdminsOnly: "Only an administrator can mark a proforma invoice administrator-only.",
    amendReason: "Reason for amending an invoiced proforma invoice",
    amendReasonHint: "This proforma invoice already has an invoice. It can still be amended, but the reason (5 characters or more) is required and is kept in the document history. Afterwards, open the invoice and re-select this proforma invoice to pull the new prices — the invoice number stays. Once a delivery note exists it can no longer be amended.",
    confirmDelete: "Delete PI {{number}}? It will be archived.",
    errorSave: "Could not save the proforma invoice.",
    openBalance: "Open balance",
    contactPerson: "Contact person",
    billToContactPerson: "Bill to (contact person)",
    notifyPartyCustomer: "Notify party",
    notifyPartyContactPerson: "Notify party (contact person)",
    consigneeCustomer: "Consignee",
    consigneeContactPerson: "Consignee (contact person)",
    shippingMarks: "Shipping marks",
    customerDept: "Customer department",
    portOfLoading: "Port of loading",
    countryOfOrigin: "Country of origin",
    dnNo: "D/N No.",
    currency: "Currency",
    upcharge: "Upcharge",
    discountPct: "LESS (%)",
    unknownCustomer: "(customer no longer in the list)",
    selectCustomer: "Select customer",
    selectContact: "Select contact person",
    selectPaymentCompany: "Select payment company",
    paymentCompanyMissing: "No payment company selected — the printed document will have no bank details.",
    selectShippingMark: "Select shipping mark",
    selectRespBy: "Select responsible person",
    noRespByOptions: "Could not load the staff list — type the responsible person.",
    respByFromStaff: "Active staff who may create or edit PIs and can see this customer's company. Adding people, disabling accounts or changing permissions in User management updates this list.",
    respByKept: "{{name}} (saved on this PI)",
    termsAutofilled: "Auto-filled from the customer's payment terms (buyer)",
    duplicatePo: "Customer PO \"{{po}}\" is already used on PI {{piNo}}.",
    addProducts: "Add products",
    searchProducts: "Search products by code",
    addToInvoice: "Add to PI",
    paymentNote: "Note",
  },
  analytics: {
    noData: "No data for this period.",
    region: "Team",
    regionHint: "See each team's sales on its own.",
    orders: "Orders",
    summary: "Summary",
    count: "Count",
    dimension: "Dimension",
    avgOrderValue: "Avg order value",
    totalQuantity: "Total quantity",
    byRespBy: "Revenue by responsible",
    byProductType: "Revenue by product type",
    subtitle: "Sales by product, customer and month",
    totalBilled: "Total billed (PIs)",
    productsSold: "Products sold",
    activeCustomers: "Active customers",
    topProductsRevenue: "Top products · revenue",
    topCustomersRevenue: "Top customers · revenue",
    revenueByMonth: "Revenue by month",
    errorLoad: "Could not load analytics.",
  },
  insight: {
    from: "From",
    to: "To",
    reset: "Reset",
    defaultPeriod: "Default: {{from}} – {{to}}",
    presetDay: "Last day",
    presetWeek: "Last week",
    presetMonth: "Last month",
    presetsLabel: "Quick period",
    presetHint: "Rolling period ending today (Vietnam time): last day = yesterday and today, last week = 7 days back, last month = the same day last month. The dates fill the boxes, so you see exactly what is counted.",
    rangeReversed: "Start date is after end date",
  },
  profit: {
    subtitle: "PI revenue vs product cost · gross margin",
    revenue: "Revenue",
    cost: "Cost",
    costIncomplete: "Cost missing",
    costIncompleteHint: "At least one line has no purchase price and no catalog cost, so it counts as 0 — the margin shown is higher than reality.",
    costIncompleteNotice: "{{count}} proforma invoice(s) have lines with no cost on record. Their cost counts as 0, so the margin above is overstated.",
    totalQuantity: "{{count}} pcs ordered",
    costFromPo: "{{withPo}}/{{total}} PIs use real purchase-order cost",
    grossMargin: "Gross margin",
    marginPercent: "Margin %",
    margin: "Margin",
    errorLoad: "Could not load profit summary. Admin or manager permission is required.",
  },
  invoices: {
    subtitle: "Issued 1:1 from proforma invoices",
    invoiceNo: "Invoice No.",
    document: "Invoice",
    errorLoad: "Could not load invoices.",
    notFound: "Invoice not found.",
    fromPiSummary: "{{customer}} · from PI {{pi}}",
    title: "Invoices",
    newInvoice: "New invoice",
    piNo: "PI No.",
    selectPi: "Select proforma invoice",
    noAvailablePi: "No un-invoiced proforma invoices available.",
    piOption: "PI {{piNo}} · {{customer}} · {{currency}} {{amount}}",
    errorCreate: "Could not create the invoice.",
    errorSave: "Could not save the invoice.",
    copiedFromPi: "Copied from the proforma invoice",
    editInvoice: "Edit invoice",
    editHint: "Only the date, bill-to contact and customer PO may differ from the PI. Everything else is copied.",
    changePi: "Change source PI",
    changePiWarning: "Changing the PI re-copies the whole header and every line item from the new PI.",
    searchPiHint: "Search by PI No. or customer PO",
    numberAssigned: "Assigned on save",
    confirmDelete: "Delete invoice {{number}}? It will be archived.",
    errorDelete: "Could not delete the invoice.",
  },
  purchaseOrders: {
    subtitle: "Supplier orders · created from PIs at cost",
    alreadyOnOrder: "Already on this order — adding it again creates a second line.",
    alreadyOnOrderShort: "· on order",
    orderNo: "PO No.",
    errorLoad: "Could not load purchase orders.",
    expectedDelivery: "Expected delivery",
    new: "New purchase order",
    document: "Purchase Order",
    orderDate: "Order date",
    actualDelivery: "Actual delivery",
    paymentTerms: "Payment terms",
    shippingMethod: "Shipping method",
    supplierSection: "Supplier information",
    orderDetails: "Order details",
    selectContact: "Select a contact",
    contactPerson: "Contact person",
    linkPi: "Link to proforma invoice",
    linkPiHint: "Pick a PI to auto-fill the supplier and lines at cost.",
    piAlreadyLinked: "PI {{number}} is already linked to purchase order {{po}}.",
    taxPercent: "Tax (%)",
    tax: "Tax",
    addProduct: "Add product",
    noItems: "No items added yet.",
    selectSupplierFirst: "Select a supplier before adding products.",
    supplierMismatch: "{{product}} does not belong to {{supplier}}.",
    supplierChangeClears: "Changing the supplier clears the current line items.",
    supplierRequired: "A supplier is required.",
    itemsRequired: "At least one line item is required.",
    expectedRequired: "Expected delivery date is required.",
    loading: "Loading purchase order…",
    errorSave: "Could not save the purchase order.",
    confirmDelete: "Delete purchase order {{number}}? It will be archived.",
    notFound: "Purchase order not found.",
    numberAssigned: "Assigned on save",
    numberYearHint: "The year in the PO number comes from the issue date, not the order date.",
    searchPi: "Search PI by PI No. or customer PO",
    clearPi: "Clear PI",
    linkedPi: "Linked PI",
    createFromPi: "Build purchase orders from this PI",
    createFromPiHint: "The lines are grouped by supplier and one purchase order is raised per supplier, priced at product cost.",
    createdCount: "{{count}} purchase orders created.",
    supplierReadOnly: "From the supplier record",
    invalidTax: "Enter a tax percentage between 0 and 100.",
    errorDelete: "Could not delete the purchase order.",
  },
  packingLists: {
    subtitle: "Cartons · created from PIs",
    listNo: "PL No.",
    errorLoad: "Could not load packing lists.",
    piInvoice: "PI / Invoice No.",
    shippingMode: "Shipping mode",
    weightKgs: "Weight N/G (kg)",
    newPackingList: "New packing list",
    attention: "Attention",
    shippingMarks: "Shipping marks",
    selectPi: "Proforma invoice",
    selectPiHint: "Search by PI No., invoice No., bill-to or ship-to",
    piLocked: "The PI cannot be changed after the packing list is created.",
    availableItems: "Items available to pack",
    originalQty: "Original qty",
    remainingQty: "Remaining qty",
    depleted: "Fully packed",
    ctnNo: "CTN No.",
    shipTo: "Ship to",
    newCtn: "New carton",
    removeCtn: "Remove carton",
    addToCtn: "Add to carton",
    emptyCtn: "Empty carton — add items above",
    netWeight: "N.W. (kg)",
    grossWeight: "G.W. (kg)",
    measurement: "Measurement (cm)",
    itemNo: "Item No.",
    subRef: "Sub ref.",
    customerPo: "Customer PO",
    errorNoCtn: "Create at least one carton before saving.",
    errorEmptyCtn: "{{count}} carton(s) are empty. Add items or remove them.",
    errorOverQty: "Maximum available quantity is {{max}}.",
    errorSave: "Could not save the packing list.",
    invoiceNo: "Invoice No.",
    selectCtn: "Select carton",
    available: "Available",
    packedQty: "Packed",
    noCtns: "No cartons yet.",
    noPiSelected: "Select a proforma invoice first.",
    errorLoadPi: "Could not load the proforma invoice.",
    confirmDelete: "Delete packing list {{number}}? It will be archived.",
    empty: "No packing lists yet.",
  },
  deliveryNotes: {
    sourceLockedHint: "The source document is fixed once the note is created — changing it would wipe the delivered quantities. Picked the wrong source? Delete this note and create a new one from the right document.",
    shipTo: "Ship to",
    subtitle: "Shipments · from packing lists or invoices",
    noteNo: "DN No.",
    billTo: "Bill to",
    errorLoad: "Could not load delivery notes.",
    deliveryDate: "Delivery date",
    newDeliveryNote: "New delivery note",
    deliveryStatus: "Delivery status",
    refType: "Reference type",
    fromPacking: "From packing list",
    fromInvoice: "From invoice",
    selectReference: "Source document",
    deliveryMode: "Delivery mode",
    deliveryModeHint: "e.g. truck, van, courier",
    vehicleNo: "Vehicle No.",
    driverName: "Driver name",
    driverPhone: "Driver phone",
    itemNo: "Item No.",
    ctnNo: "CTN No.",
    subRef: "Sub ref.",
    orderedQty: "Ordered qty",
    deliveredQty: "Delivered qty",
    lineRemarks: "Line note",
    errorNoReference: "Select a packing list or invoice first.",
    errorSave: "Could not save the delivery note.",
    confirmDelivery: "Confirm delivered quantities",
    created: "Delivery note {{number}} created.",
    changeStatus: "Change delivery status",
    totalOrdered: "Total ordered",
    totalDelivered: "Total delivered",
    deliveredCap: "Delivered quantity cannot exceed the ordered quantity.",
    noItems: "This delivery note has no lines.",
    errorCreate: "Could not create the delivery note.",
    confirmDelete: "Delete delivery note {{number}}? It will be archived.",
    empty: "No delivery notes yet.",
  },
  statement: {
    sheetSummary: "summary",
    sheetDetails: "details",
    sheetAging: "aging",
    agingAll: "Aging · all customers in view",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    overdueDays: "{{count}}d overdue",
    bucket: "Aging bucket",
    exportSheets: "Export Excel (3 sheets)",
    totalBilled: "Total billed",
    totalPaid: "Total paid",
    recovered: "recovered",
    outstanding: "Outstanding",
    overdue: "Overdue",
    overdueCount: "{{count}} document(s)",
    billedShort: "Billed",
    paidShort: "Paid",
    subtitle: "Accounts receivable · aging by customer",
    allCustomers: "All customers",
    noBalances: "No outstanding balances",
    allSettled: "All invoices are settled.",
    errorLoad: "Could not load statement.",
  },
  users: {
    subtitle: "Accounts & roles · server-enforced permissions",
    newUser: "New user",
    createUser: "Create user",
    user: "User",
    errorCreate: "Could not create user.",
    errorLoad: "Could not load users. Administrator permission is required.",
    editUser: "Edit user",
    changeRole: "Change role",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match.",
    you: "you",
    resetPassword: "Reset password",
    disableUser: "Disable account",
    enableUser: "Enable account",
    lastAdminProtected: "The last administrator cannot be downgraded.",
    selfDowngradeBlocked: "You cannot reduce your own administrator privileges. Ask another administrator.",
    confirmRoleChange: "Remove administrator privileges from {{email}}?",
    errorUpdate: "Could not update the user.",
  },
  settings: {
    sectionsLabel: "Settings sections",
    catalogTab: "Catalog",
    catalogTabHint: "Product dictionaries",
    companyTab: "Company",
    companyTabHint: "Identity and contacts",
    outputTab: "Output",
    outputTabHint: "Printers and documents",
    masterDataEyebrow: "Master data",
    organisationEyebrow: "Organisation",
    outputEyebrow: "Output",
    catalogOptions: "Catalog options",
    productTypes: "Product types",
    productTypesDescription: "Controls the Type dropdown in New and Edit Product. The order here is the order shown in the form. The Chinese name (optional) is shown under the English name on product screens.",
    productTypePlaceholder: "e.g. Snap fastener",
    productUnits: "Product units",
    productUnitsDescription: "Controls the Unit dropdown in New and Edit Product. Existing catalog units are included automatically.",
    productUnitPlaceholder: "e.g. gross",
    configuredCount: "{{count}} configured",
    addOption: "Add option",
    optionLabelZh: "Chinese name",
    optionExists: "This option already exists.",
    moveUp: "Move up",
    moveDown: "Move down",
    removeOption: "Remove option",
    minimumOneOption: "At least one option is required",
    companyInformation: "Company information",
    companyName: "Company name",
    labelPrinter: "Thermal label printer (CT321D)",
    labelPreset: "Label size preset",
    labelCustom: "Custom size…",
    labelSizeInvalid: "Label size is invalid ({{field}}). Use 20–100 mm.",
    widthMm: "Width (mm)",
    heightMm: "Height (mm)",
    labelRotate: "Rotate the content 90° when printing",
    errorLoad: "Could not load settings.",
    errorSave: "Could not save settings.",
    paymentTerms: "Payment terms",
    paymentTermsDescription: "Controls the Payment terms dropdown on customers, purchase orders, and proforma invoices. The order here is the order shown in the form.",
    paymentTermsPlaceholder: "e.g. After Statement 30 Days",
    shippingMethods: "Shipping methods",
    shippingMethodsDescription: "Controls the Shipping method dropdown on purchase orders.",
    poPriorities: "Purchase order priorities",
    poPrioritiesDescription: "Controls the Priority dropdown on purchase orders.",
    paymentCompanies: "Payment companies",
    paymentCompaniesDescription: "Beneficiary and bank account details printed on every proforma invoice and invoice.",
    addCompany: "Add company",
    defaultCompany: "Default",
    companyLogo: "Logo on printed documents",
    noLogo: "No logo — the default Hisense mark is printed",
    uploadLogo: "Upload logo",
    beneficiary: "Beneficiary",
    beneficiaryBank: "Beneficiary bank",
    bankAddress: "Bank address",
    swiftCode: "SWIFT code",
    accountNumberUsd: "USD account number",
    accountNumberHkd: "HKD account number",
    accountNumberRmb: "RMB account number",
    setAsDefaultCompany: "Set as default company",
    lastUpdated: "Last updated {{when}} by {{who}}",
    counters: "Document numbers",
    countersDescription: "Read-only: the next number each series will issue.",
    defaults: "Defaults for new records",
    defaultsDescription: "Applied when a new product is created; existing records are untouched.",
    defaultCurrency: "Default currency",
    defaultProductUnit: "Default product unit",
    shippingMarks: "Shipping marks",
    shippingMarksDescription: "Preset marks offered on the proforma invoice form.",
    shippingMarkPlaceholder: "e.g. N/M",
    weightUnits: "Weight units",
    weightUnitsDescription: "Units offered next to a product's weight per 100 pieces.",
    weightUnitPlaceholder: "e.g. kg",
    currencies: "Currencies",
    currencyPlaceholder: "e.g. USD",
    shippingMethodPlaceholder: "e.g. Sea Freight",
    poPriorityPlaceholder: "e.g. Urgent",
    quotationPreparedByPlaceholder: "e.g. Louis Chen",
    currenciesDescription: "Controls the Currency dropdown on every sales and purchase document.",
    quotationPreparedBy: "Quotation \"Prepared by\" options",
    quotationPreparedByDescription: "Controls the Prepared by dropdown on quotations.",
    labTestStandards: "Lab test standards",
    labTestStandardsDescription: "Controls the Lab test request dropdown in New and Edit Sample Order. The order here is the order shown in the form.",
    supplierSpecializations: "Supplier specializations",
    supplierSpecializationsDescription: "Controls the Specialization dropdown on supplier contacts. The order here is the order shown in the form.",
    supplierSpecializationPlaceholder: "e.g. Plastic Stopper",
  },
  archive: {
    searchPlaceholder: "Search document no., customer PO, deleted by…",
    allTypes: "All types",
    documentNo: "Document no.",
    party: "Party",
    viewSnapshot: "View original data",
    notRestorable: "Audit copy only",
    notRestorableHint: "This table is deleted permanently; the archive keeps a copy for the audit trail but the record cannot be put back.",
    confirmRestore: "Restore this record? It will reappear in its list and in reports.",
    snapshotTitle: "Original data of the deleted record",
    snapshotRedacted: "Supplier cost and supplier details are hidden for your role.",
    errorRestore: "This record could not be restored.",
    restoreProductTitle: "Restore with a new code or Sub Ref",
    restoreProductHint: "Enter a different code or Sub Ref for the deleted product, then restore it. The product already using the old pair is not changed.",
    openConflictingProduct: "Open the product using this pair (new tab)",
    subtitle: "Audit archive · restore soft-deleted records",
    empty: "Archive is empty",
    emptyHint: "Deleted records will appear here for restore.",
    errorLoad: "Could not load archive. Administrator permission is required.",
  },
  resourceTypes: {
    piAttachments: "Order evidence file (PI)",
    pProcessAttachments: "P-Process photo",
    customerRequirements: "Customer product requirement",
    customerRequirementPhotos: "Customer requirement photo",
    routings: "Routing",
    customers: "Customer",
    suppliers: "Supplier",
    products: "Product",
    proformaInvoices: "Proforma Invoice",
    invoices: "Invoice",
    quotations: "Quotation",
    purchaseOrders: "Purchase Order",
    packingLists: "Packing List",
    deliveryNotes: "Delivery Note",
    sampleOrders: "Sample Order",
    sampleCards: "Sample Card",
    boms: "Bill of Materials",
    salesOrders: "Sales Order",
    purchaseRequisitions: "Purchase Requisition",
    warehouses: "Warehouse",
    warehouseBins: "Warehouse location",
    stockMoves: "Stock Move",
    productionResources: "Production resource",
    workOrders: "Work Order",
    inspections: "Inspection",
    glAccounts: "GL Account",
    journalEntries: "Journal Entry",
    serviceTickets: "Service Ticket",
    qualitySpecs: "Quality specification",
    mrpRuns: "MRP scenario",
    unitProfiles: "Unit profile",
    piPayments: "PI payment",
    salesOpportunities: "Sales opportunity",
    serviceCases: "After-sales case",
    sourcingCases: "RFQ",
    subcontractOrders: "Subcontract order",
  },
  comingSoon: {
    title: "Under construction",
    description: "This feature is being built and will be available soon. Thank you for your patience.",
    backToOverview: "Back to overview",
  },
  status: {
    paid: "Paid",
    partial: "Partial",
    unpaid: "Unpaid",
    approved: "Approved",
    pending: "Pending",
    underReview: "Under Review",
    rejected: "Rejected",
    draft: "Draft",
    active: "Active",
    inactive: "Inactive",
    disabled: "Disabled",
    obsolete: "Obsolete",
    confirmed: "Confirmed",
    sent: "Sent",
    delivered: "Delivered",
    partiallyDelivered: "Partially Delivered",
    inTransit: "In Transit",
    received: "Received",
    testing: "Testing",
    completed: "Completed",
    inProduction: "In Production",
    shipped: "Shipped",
    closed: "Closed",
    cancelled: "Cancelled",
    ordered: "Ordered",
    in: "In",
    out: "Out",
    transfer: "Transfer",
    adjust: "Adjust",
    planned: "Planned",
    released: "Released",
    inProgress: "In Progress",
    done: "Done",
    pass: "Pass",
    fail: "Fail",
    incoming: "Incoming",
    inProcess: "In-process",
    final: "Final",
    asset: "Asset",
    liability: "Liability",
    equity: "Equity",
    revenue: "Revenue",
    expense: "Expense",
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    open: "Open",
    resolved: "Resolved",
    current: "Current",
    paymentProgress: "{{status}} — {{percent}}%",
  },
  roles: {
    admin: "Administrator",
    manager: "Manager",
    accountant: "Accountant",
    viewer: "Viewer",
  },
  account: {
    security: "Security",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    passwordHint: "At least 8 characters.",
    passwordMismatch: "The two new passwords do not match.",
    passwordChanged: "Password changed. It applies the next time you sign in.",
    errorChangePassword: "Could not change the password.",
    // Chân thanh bên (19/09/2026): tài khoản chọn từng màn hình không hiện vai trò gốc — "Người xem" dưới tên nhân viên mua hàng là sai.
    customAccess: "Custom access",
  },
  label: {
    printer: "Label printer",
    print: "Print label",
    count: "Number of labels",
    qty: "Sample qty",
    qtyHint: "Optional — overrides the quantity printed on the label.",
    dialogHint: "Print opens your computer's print dialog — pick the label printer there. The printer must already be installed on this computer; if it is not, it will not be in the list and the label will come out of a paper printer.",
    sizeInUse: "Label size {{w}} × {{h}} mm, from Settings.",
    error: {
      badSize: "The label size in Settings is invalid ({{field}}). Fix it before printing.",
    },
  },
  errors: {
    supplierRegion: "This account only works with suppliers of its own region. Ask an administrator to create or move this supplier.",
    followerInvalid: "An order follower must be an active staff account (not a disabled or supplier-portal account).",
    followerRegion: "This order follower cannot see customers of this region. Change their data region in Permissions, or pick someone else.",
    privateAdminOnly: "Only an administrator can change privacy settings or who may see a private record.",
    privateSupplier: "This record uses a private supplier you are not permitted to see. Only administrators and that supplier's followers can change it.",
    unauthorized: "Your session has expired. Please sign in again.",
    readOnly: "You have view-only access to this record — the fields are locked, not broken.",
    forbidden: "You do not have permission to perform this action.",
    customerTerms: "You may not change this customer's payment terms or order requirements (the Payment terms & order requirements tick in permissions).",
    validation: "Some information is invalid. Review the form and try again.",
    notFound: "This record no longer exists or is unavailable.",
    emailTaken: "This email address is already in use.",
    invoiceExists: "This proforma invoice already has an invoice.",
    currencyMismatch: "The price currency must match the product currency.",
    notRestorable: "This archived record cannot be restored.",
    noFile: "Choose an image to upload.",
    badImageType: "Only PNG, JPEG, WEBP, or GIF images are supported.",
    imageTooLarge: "The image must be 5 MB or smaller.",
    companyTaken: "A customer with this company name already exists.",
    supplierCompanyTaken: "A supplier with this company name already exists in the same region (or unclassified).",
    portalLoginIdTaken: "Another supplier already uses this login id. Every supplier must have its own.",
    portalLoginIdFormat: "A login id is 3–40 characters: letters, digits, dash or underscore, no spaces and no @.",
    portalAccountExists: "This supplier already has a portal account.",
    portalAccountMissing: "This supplier has no portal account yet.",
    originalRowMissing: "The original record is no longer in the system, only the archive. It cannot be restored — the archive is kept.",
    customerRequired: "Select a customer (Bill To).",
    customerRegion: "This account only works with customers of its own region. Ask an administrator to create or move this customer.",
    paymentCompanyRequired: "Select a payment company.",
    itemsRequired: "Add at least one line item.",
    forbiddenTitle: "You do not have access to this page",
    forbiddenBody: "Your account is not granted permission to view this page. Contact an administrator if you need it.",
    forbiddenGoHome: "Go to my home page",
    productCodeExhausted: "Could not issue an unused product code. Enter one manually.",
    piAlreadyLinked: "This proforma invoice is already linked to a purchase order.",
    supplierMismatch: "A line item does not belong to the selected supplier.",
    duplicateCtnNo: "Carton numbers must be unique.",
    overPacked: "The packed quantity exceeds the proforma invoice line.",
    unknownLine: "A line does not belong to this delivery note.",
  },
  print: {
    code: "Code",
    description: "Description",
    colorSize: "Color / Size",
    qty: "Qty",
    unitPrice: "Unit price",
    amount: "Amount",
    subtotal: "Subtotal",
    upcharge: "Upcharge",
    less: "Less ({{pct}}%)",
    grandTotal: "GRAND TOTAL",
    total: "Total",
    remarks: "Remarks",
    generated: "Generated {{date}}",
  },
  erpResource: {
    errorLoad: "Could not load this module.",
    errorCreate: "Could not create the record.",
    subtitles: {
      boms: "Bills of materials · multi-level norms",
      salesOrders: "End-to-end sales orders · credit control",
      requisitions: "Purchase requisitions · MRP demand",
      warehouses: "Storage locations",
      stockMoves: "Goods in / out / transfer / adjust",
      workOrders: "Production work orders · output",
      inspections: "Incoming / in-process / final QC",
      glAccounts: "Chart of accounts",
      journalEntries: "Journal · business-finance integration",
      serviceTickets: "After-sales service & RMA",
    },
    fields: {
      product: "Product",
      productCode: "Product code",
      version: "Version",
      status: "Status",
      soNo: "SO No.",
      orderDate: "Order date",
      total: "Total",
      customer: "Customer",
      remarks: "Remarks",
      prNo: "PR No.",
      neededBy: "Needed by",
      code: "Code",
      name: "Name",
      location: "Location",
      moveNo: "Move No.",
      type: "Type",
      qty: "Qty",
      when: "When",
      quantity: "Quantity",
      reference: "Reference",
      woNo: "WO No.",
      planned: "Planned",
      produced: "Produced",
      description: "Description",
      plannedQty: "Planned qty",
      dueDate: "Due date",
      qcNo: "QC No.",
      result: "Result",
      rejected: "Rejected",
      referencePoWo: "Reference (PO/WO)",
      qtyInspected: "Qty inspected",
      qtyRejected: "Qty rejected",
      notes: "Notes",
      accountType: "Type",
      jeNo: "JE No.",
      date: "Date",
      memo: "Memo",
      debit: "Dr",
      credit: "Cr",
      amount: "Amount",
      debitAccount: "Debit account",
      creditAccount: "Credit account",
      sourceRef: "Source ref",
      ticket: "Ticket",
      subject: "Subject",
      priority: "Priority",
      supplier: "Supplier",
    },
  },
};

export type Dict = typeof en;
